// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1g-fL","filesListContainer":"PosDisputesFiles_filesListContainer__1NRCi","filesButton":"PosDisputesFiles_filesButton__1sgPL"};